export function updateDocumentElement(id: string, updateFn: (element: HTMLElement) => void) {
  const element = document.getElementById(id);
  if (element != null) {
    updateFn(element);
  }
}
